import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocuploadService {

   constructor(
     private http: HttpClient,
     private session: SessionService,
   ) { 
     environment.API_URL = this.session.GetUserDetails().ApiUrl;
   }
 
   MasterDocument(Detail: any) { 
     return this.http.post<any>(environment.API_URL + `MasterDocument/Load`,
       this.session.SetClass(Detail)
     ).pipe(map(response => {
       if (response.Error_Code == '11' || response.Error_Code == '02') {
         this.session.End();
       } else {
         return response;
       }
     }));
   }

   DocFillCombo(Detail: any) { 
    return this.http.post<any>(environment.API_URL + `DocFillCombo/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
 
}
